import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const MewsPreInstallationForm = ({ form }: Props) => {
	const {
		register,
		formState: { errors },
	} = form;
	const { t } = useTranslation();

	return (
		<FormInput
			register={register}
			errors={errors}
			name="settings.accesstoken"
			label={t("modules.app.field.access_token.title")}
		/>
	);
};

export default MewsPreInstallationForm;
